import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class AppData
{
	constructor()
	{

	}

	public set(key: string, value: any)
	{
		sessionStorage.setItem(key, JSON.stringify(value));
	}

	public get(key: string)
	{
		if(sessionStorage.getItem(key) == 'undefined')
		{
			return undefined
		}
		let response = JSON.parse(<any>sessionStorage.getItem(key));
		if(key == 'buildingData' && response == undefined)
		{
			return {};
		}
		return response;
	}
	
	public delete(key: string)
	{
		sessionStorage.removeItem(key);
	}

	public clearAll()
	{
		sessionStorage.clear();
	}
}
